import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import UnorderedListMenu from './UnorderedListMenu';

const messages = defineMessages({
  ul: {
    id: 'Elenco puntato',
    defaultMessage: 'Elenco puntato',
  },
});

export const ULElement = ({ attributes, children, element }) => {
  return <ul {...attributes}>{children}</ul>;
};

const ULButton = (props) => {
  const intl = useIntl();
  return (
    <UnorderedListMenu {...props} title={intl.formatMessage(messages.ul)} />
  );
};

export default function install(config) {
  const { slate } = config.settings;

  slate.buttons['bulleted-list'] = ULButton; //override default bulleted-list button

  slate.elements['ul'] = ULElement;

  //il deserializer html per aggiungere le classi è definito in deserializers.js
  return config;
}
